import React from 'react';
import styles from './overlay.scss';
import classNames from 'classnames';

const Overlay = () => <div className={classNames(styles.overlay, 'overlay', 'button-background-color')}/>;

export default Overlay;



// WEBPACK FOOTER //
// ./app/components/overlay/overlay.js